<app-report-toolbar> </app-report-toolbar>

<ng-template #salesOrderConfirmation>
  <app-sales-order-confirmation-report
    [salesOrderHeaderId]="salesOrderHeaderId"
  ></app-sales-order-confirmation-report>
</ng-template>

<ng-template #salesOrderBalances>
  <app-sales-order-balances [salesOrderHeaderId]="salesOrderHeaderId"></app-sales-order-balances>
</ng-template>

<ng-template #salesBackOrder>
  <app-sales-back-order [salesOrderHeaderId]="salesOrderHeaderId"></app-sales-back-order>
</ng-template>

<ng-template #salesQuotation>
  <app-sales-order-confirmation-report [salesOrderHeaderId]="salesOrderHeaderId"></app-sales-order-confirmation-report>
</ng-template>

<ng-template #proformaReport>
  <app-proforma-report [salesOrderHeaderId]="salesOrderHeaderId"></app-proforma-report>
</ng-template>

<ng-template #depositReport>
  <app-sales-deposit-report [salesOrderHeaderId]="salesOrderHeaderId"></app-sales-deposit-report>
</ng-template>

<ng-template #pickingList>
  <app-picking-list [salesOrderHeaderId]="salesOrderHeaderId"></app-picking-list>
</ng-template>
